import styled from "styled-components";

export const CommentComponentWrapper = styled.div`
  max-width: 75%;
  @media screen and (max-width: 768px) {
    max-width: 100%;
  }
  & button {
    &.more-comments-btn {
      font-size: var(--font-size-sm);
      color: var(--blue-color-dark);
    }
    &.add-comment-btn {
      border: var(--blue-color-dark) 1px dotted;
      border-radius: 12px;
      font-size: var(--font-size-lg);
      color: var(--blue-color-dark);
      font-weight: 500;
      padding: 0.5rem 6.25rem;
      @media screen and (max-width: 576px) {
        font-size: var(--font-size-base);
      }
    }
  }
  form {
    label {
      color: var(--blue-color-dark);
      font-size: var(--font-size-md);
    }
    .form-control.comment-input {
      height: 45px;
      font-size: var(--font-size-sm);
      border: var(--blue-color-dark) 1px dotted;
      border-radius: 12px;
    }
    textarea.form-control.comment-input {
      min-height: 180px;
    }
    button.comment-submit {
      width: 45%;
    }
    @media screen and (max-width: 576px) {
      label {
        font-size: var(--font-size-base);
      }
      textarea.form-control.comment-input {
        min-height: 290px;
      }
      button.comment-submit {
        width: 100%;
        font-size: var(--font-size-base);
      }
    }
  }
`;

export const CommentWrapper = styled.article`
  display: grid;
  grid-template-columns: 1fr 5fr max-content;
  grid-template-areas: "image content date";
  border-bottom: 1px solid var(--deactive-color);
  figure {
    grid-area: image;
    gap: 6px;
    figcaption {
      color: var(--blue-color-dark);
      font-size: var(--font-size-sm);
    }
  }
  .content {
    grid-area: content;
    .title {
      font-size: var(--font-size-base);
      color: var(--blue-color-dark);
    }
    .text {
      font-size: var(--font-size-sm);
    }
  }
  time {
    grid-area: date;
    text-align: left;
  }
  @media screen and (max-width: 576px) {
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      "image date"
      "content content";
    figure {
      img {
        width: 33px;
        height: 33px;
      }
      figcaption {
        font-size: 10px;
        font-weight: 500;
      }
    }
    .content p.title,
    .content p.text {
      font-size: var(--font-size-xs);
    }
    time {
      font-size: 10px;
    }
  }
`;
